import Vue from 'vue';

const eventBus = new Vue();
eventBus.events = {
  TEST_EVENT: 'test-event',
};

export default eventBus;
